import { useEffect, useRef } from 'react';

const possibleColors = [
  'DodgerBlue',
  'OliveDrab',
  'Gold',
  'Pink',
  'SlateBlue',
  'LightBlue',
  'Gold',
  'Violet',
  'PaleGreen',
  'SteelBlue',
  'SandyBrown',
  'Chocolate',
  'Crimson',
];

function randomFromTo(from, to) {
  return Math.floor(Math.random() * (to - from + 1) + from);
}

export default function Confetti({
  speed = 3,
  size = { min: 11, max: 33 },
  maxConfettis = 150,
  tiltIncrement = { min: 0.01, max: 0.05 },
  colors = possibleColors,
}) {
  const canvasRef = useRef(null);
  const particles = [];

  useEffect(() => {
    let W = window.innerWidth;
    let H = window.innerHeight;
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    function confettiParticle() {
      this.x = Math.random() * W; // x
      this.y = Math.random() * H - H; // y
      this.r = randomFromTo(size.min, size.max); // radius
      this.d = Math.random() * maxConfettis + size.min;
      this.color = colors[Math.floor(Math.random() * colors.length)];
      this.tilt = Math.floor(Math.random() * 33) - 11;
      this.tiltAngleIncremental =
        Math.random() * (tiltIncrement.max - tiltIncrement.min) +
        tiltIncrement.min;
      this.tiltAngle = 0;

      this.draw = function () {
        context.beginPath();
        context.lineWidth = this.r / 2;
        context.strokeStyle = this.color;
        context.moveTo(this.x + this.tilt + this.r / 3, this.y);
        context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5);
        return context.stroke();
      };
    }

    function Draw() {
      const results = [];

      requestAnimationFrame(Draw);

      context.clearRect(0, 0, W, window.innerHeight);

      for (var i = 0; i < maxConfettis; i++) {
        results.push(particles[i].draw());
      }

      let particle = {};
      for (var j = 0; j < maxConfettis; j++) {
        particle = particles[j];

        particle.tiltAngle += particle.tiltAngleIncremental;
        particle.y += (Math.cos(particle.d) + speed + particle.r / 2) / 2;
        particle.tilt = Math.sin(particle.tiltAngle - j / 3) * 15;

        if (particle.x > W + 30 || particle.x < -30 || particle.y > H) {
          particle.x = Math.random() * W;
          particle.y = -30;
          particle.tilt = Math.floor(Math.random() * 10) - 20;
        }
      }

      return results;
    }

    function handleResize() {
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    window.addEventListener('resize', handleResize, false);

    for (var i = 0; i < maxConfettis; i++) {
      particles.push(new confettiParticle());
    }

    canvas.width = W;
    canvas.height = H;
    Draw();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [speed, size, maxConfettis, tiltIncrement, colors]);

  return <canvas className="z-50 pointer-events-none" ref={canvasRef}></canvas>;
}
